
  
    <ion-content color="light">
      <ion-toolbar>
        <ion-title>Edit Day</ion-title>
        <ion-buttons slot="end">
          <ion-button color="light" (click)="closeModal()"
            ><ion-icon name="close-circle-outline"></ion-icon></ion-button
          >
        </ion-buttons>
      </ion-toolbar>

      <div class="w-[90%] my-4 mx-auto">
        <form [formGroup]="editDayForm" class="space-y-6 md:space-y-4">
          <!-- <div class="">
            <label
              for="first-name"
              class="block text-sm font-medium text-[#797979]"
              >Dwell Date</label
            >
            <div class="mt-1">
              <input
                type="date"
                formControlName="dwell_date"
                class="block w-full h-12 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <p
              class="mt-2 text-sm text-red-600"
              id="firstname-error"
              *ngIf="productInsertForm.get('dwell_date')?.hasError('required') && (productInsertForm.get('dwell_date')?.touched || productInsertForm.get('dwell_date')?.dirty)"
            >
              Date is required
            </p>
          </div> -->
          <div>
            <label
              for="first-name"
              class="block text-sm font-medium text-[#797979]"
              >Monitoring Date<span style="color: red;">*</span></label
            >
            <div class="mt-1">
              <input
                type="date"
                formControlName="monitoring_date"
                max="{{ today | date:'yyyy-MM-dd' }}"
                class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>
            <p
              class="mt-2 text-sm text-red-600"
              id="firstname-error"
              *ngIf="editDayForm.get('monitoring_date')?.hasError('required') && (editDayForm.get('monitoring_date')?.touched || editDayForm.get('monitoring_date')?.dirty)"
            >
              Monitoring Date is required
            </p>
          </div>

          <div class="">
            <label
              for="first-name"
              class="block text-sm font-medium text-[#797979]"
              >Securement</label
            >
            <div class="mt-1">
              <ng-select
                class="w-[100%] rounded-md border-gray-300"
                formControlName="securement"
                name="vessel"
                [searchable]="false"
                [clearable]="false"
              >
                <ng-option [value]="''">Select an option</ng-option>
                <ng-option [value]="'Cath Securement Drsg'">Cath Securement Drsg</ng-option>
                <ng-option [value]="'None'">None</ng-option>
                <ng-option [value]="'Sutureless'">Sutured</ng-option>
                <ng-option [value]="'Sutureless Device'">Sutureless Device</ng-option>
              </ng-select>
            </div>
            <!-- <p
              class="mt-2 text-sm text-red-600"
              id="firstname-error"
              *ngIf="productInsertForm.get('securement')?.hasError('required') && (productInsertForm.get('securement')?.touched || productInsertForm.get('securement')?.dirty)"
            >
              Securement is required
            </p> -->
          </div>

          <div class="">

            <label
              for="first-name"
              class="block text-sm font-medium text-[#797979]"
              >Device Related Adverse Events</label
            >
            <div class="mt-1">
              <ng-select
              class="w-[100%] mt-1 rounded-md border-gray-300"
              formControlName="device_related_adverse_events"
              name="vessel"
              [searchable]="false"
              [clearable]="false"
            >
              <ng-option [value]="null">Select an option</ng-option>
              <ng-option [value]="'Air Embolism'">Air Embolism</ng-option>
              <ng-option [value]="'Arterial Spasm'">Arterial Spasm</ng-option>
              <ng-option [value]="'Cellulitis'">Cellulitis</ng-option>
              <ng-option [value]="'CRBSI'">CRBSI</ng-option>
              <ng-option [value]="'Embolization'">Embolization</ng-option>
              <ng-option [value]="'Hematoma'">Hematoma</ng-option>
              <ng-option [value]="'Hemorrhage'">Hemorrhage</ng-option>
              <ng-option [value]="'N/A'">N/A</ng-option>
              <ng-option [value]="'Other'">Other</ng-option>
              <ng-option [value]="'Peripheral Ischemia And Infarction'">Peripheral Ischemia And Infarction</ng-option>
              <ng-option [value]="'Peripheral Nerve Injury'">Peripheral Nerve Injury</ng-option>
              <ng-option [value]="'Septicemia'">Septicemia</ng-option>
              <ng-option [value]="'Site Infection'">Site Infection</ng-option>
              <ng-option [value]="'Thrombosis'">Thrombosis</ng-option>
              <ng-option [value]="'Tissue Necrosis'">Tissue Necrosis</ng-option>
              <ng-option [value]="'Vessel Wall Perforation'">Vessel Wall Perforation</ng-option>
            </ng-select>
            </div>
        
          </div>
          <div class="">
            <label
              for="first-name"
              class="block text-sm font-medium text-[#797979]"
              >Reason for D/C</label
            >
            <div class="mt-1">
              <ng-select
                class="w-[100%] mt-1 rounded-md border-gray-300"
                formControlName="dc_reason"
                [items]="dcReasons"
                bindValue="id"
                bindLabel="name"
                [searchable]="false"
                [clearable]="false"
              >
                <ng-option [value]="null">Select an option</ng-option>
              </ng-select>
            </div>
        
          </div>
          <div class="">
            <label
              for="first-name"
              class="block text-sm font-medium text-[#797979]"
              >Notes</label
            >
            <div class="mt-1">
              <input
                type="text"
                formControlName="notes"
                class="block w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div>

          </div>
          <div class="my-4 md:my-2 grid grid-cols-2">
            <!-- <label
              for="first-name"
              class="block text-sm font-medium text-[#797979]"
              >Responsibility</label
            >
            <div class="mt-1">
              <input
                type="checkbox"
                formControlName="responsibility"
                class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
            </div> -->
            <div class="col-span-1 flex items-center">
              <input
                type="checkbox"
                formControlName="completed_therapy"
                class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
              <label
                for="first-name"
                class="block text-sm pl-1 font-medium text-[#797979]"
                > Completed Therapy
              </label>
            </div>
            <div class="col-span-1 flex items-center">
              <input
                type="checkbox"
                formControlName="dressing_intact"
                class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              />
              <label
                for="first-name"
                class="block text-sm pl-1 font-medium text-[#797979]"
                > Dressing Intact</label>
            </div>


         

          </div>
        </form>
        <div class="pt-8 md:pt-4 flex justify-between items-center space-x-2">
          <button
            (click)="closeModal()"
            class="w-full rounded-[5px] h-[40px] !bg-[#58585A] text-white"
            >
              Cancel
          </button>
          <ion-button [disabled]="!editDayForm.valid" class="w-full h-[40px] min-h-10" expand="block" (click)="submit()"
            >Edit Day</ion-button
          >
        </div>

      </div>
    </ion-content>
  
